import Vue from 'vue';
import Router from 'vue-router';
import authentication from "./authentication";

import UserProfile from './views/UserProfile.vue';

import CourseTypes from "./views/CourseTypes/CourseTypes.vue";
import ManageAssets from "./views/ManageAssets/ManageAssets.vue";
import ManageEcsCompanies from "./views/ManageEcsCompanies/ManageEcsCompanies.vue";
import ManageJobs from "./views/ManageJobs/ManageJobs.vue";
import AddPerson from "./views/ManagePersonnel/AddPerson/AddPerson.vue";
import ManagePerson from "./views/ManagePersonnel/ManagePerson.vue";
import ManagePersonnel from "./views/ManagePersonnel/ManagePersonnel.vue";
import ManageTeams from "./views/ManageTeams/ManageTeams.vue";
import PageNotFound from "./views/PageNotFound.vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            redirect: "/manage-personnel",
            name: "home",
            meta: {
                requiresAuthentication: true
            }
        },

        {
            path: "/index.html",
            redirect: "/manage-personnel",
            name: "index",
            meta: {
                requiresAuthentication: true
            }
        },

        {
            path: "/user-profile",
            name: "user profile",
            component: UserProfile,
            meta: {
                requiresAuthentication: true,
                title: "User Profile"
            }
        },
        {
            path: "/manage-personnel/add-person",
            name: "add person",
            component: AddPerson,
            props: true,
            meta: {
                requiresAuthentication: true,
                title: "Add Person"
            }
        },
        {
            path: "/manage-personnel",
            name: "manage personnel",
            component: ManagePersonnel,
            props: false,
            meta: {
                requiresAuthentication: true,
                title: "Manage Personnel"
            }
        },
        {
            path: "/manage-personnel/:personId",
            name: "manage person",
            component: ManagePerson,
            props: true,
            meta: {
                requiresAuthentication: true,
                title: "Manage Person"
            }
        },

        {
            path: "/manage-jobs",
            name: "manage jobs",
            component: ManageJobs,
            props: false,
            meta: {
                requiresAuthentication: true,
                title: "Manage Jobs"
            }
        },
        {
            path: "/manage-teams",
            name: "manage teams",
            component: ManageTeams,
            props: false,
            meta: {
                requiresAuthentication: true,
                title: "Manage Teams"
            }
        },
        {
            path: "/manage-ecs-companies/",
            name: "manage ecs companies",
            component: ManageEcsCompanies,
            meta: {
                requiresAuthentication: true,
                title: "Manage ECS Companies"
            }
        },
        {
            path: "/manage-assets",
            name: "manage assets",
            component: ManageAssets,
            props: false,
            meta: {
                requiresAuthentication: true,
                title: "Manage Assets"
            }
        },
        {
            path: "/course-types",
            name: "course types",
            component: CourseTypes,
            props: false,
            meta: {
                requiresAuthentication: true,
                title: "Course Types"
            }
        },
        {
            path: "*",
            component: PageNotFound,
            meta: { title: "404 - Not Found" }
        }
    ]
});

// Global route guard
router.beforeEach((to, from, next) => {
    // Update page title
    if (to.meta.title != undefined) {
        document.title = to.meta.title;
    } else {
        document.title = "ECS | Personnel";
    }

    if (to.matched.some(record => record.meta.requiresAuthentication)) {
        authentication.isAuthenticated();
        next();
    } else {
        next();
    }
});

export default router;
